import type { z } from "zod";

type EntityShape = {
  type?: string;
  toolInvoke?: { toolCallId?: string };
};

/**
 * Parses a catalog tool-card payload from flat args or entities[] agent shape.
 */
export function parseCatalogEntityPayload<T extends z.ZodType>(
  schema: T,
  entityType: string,
  args: unknown,
  toolCallId?: string,
  pickFields?: (entity: Record<string, unknown>) => unknown,
) {
  const direct = schema.safeParse(args);
  if (direct.success) {
    return direct;
  }

  const root = args as { entities?: EntityShape[] } | null | undefined;
  const entities = root?.entities ?? [];
  const entity =
    entities.find(
      (item) =>
        item.type === entityType &&
        (!toolCallId || item.toolInvoke?.toolCallId === toolCallId),
    ) ?? entities.find((item) => item.type === entityType);

  if (!entity) {
    return direct;
  }

  const payload = pickFields
    ? pickFields(entity as Record<string, unknown>)
    : entity;
  return schema.safeParse(payload);
}
